// test1940
(1940 && 0);
